/* eslint-disable import/no-extraneous-dependencies */
import { IMenu } from "../types";
import gear from "@ht/shared/fonts/deos-pis/gear";
import home from "@ht/shared/fonts/deos-pis/home";
import chevronDown from "@ht/shared/fonts/deos-pis/chevron-down";
import app from "@ht/shared/fonts/deos-pis/upload-doc";
import users from "@ht/shared/fonts/deos-pis/users";
import approval from "@ht/shared/fonts/deos-pis/check-circle-bold";
import monitor from "@ht/shared/fonts/deos-pis/monitor";
import calendar from "@ht/shared/fonts/deos-pis/calendar-outline-extra-small";
import award from "@ht/shared/fonts/deos-pis/award";

const getMenu = (roleName: string | undefined) => {
    const menus: IMenu[] = [
        {
            id: 1,
            label: "Dashboard",
            url: "/dashboard",
            Icon: home,
        }
    ];
    if (roleName == "supervisor" || roleName === "TOWR" || roleName === "TMGR" || roleName === "TADM") {
        menus.push({
            id: 4,
            label: "System Management",
            url: "/system-management",
            Icon: gear,
        });
    } else if (roleName == "agent") {
        menus.push({
            id: 5,
            label: "Workspace",
            url: "/workspace",
            Icon: chevronDown,
            submenu: [{
                id: 6,
                label: "Leads",
                url: "/leads",
                Icon: users
            },
            {
                id: 7,
                label: "Application Monitoring",
                url: "/workspace/application",
                Icon: app
            },
            {
                id: 8,
                label: "Approval",
                url: "#",
                Icon: approval
            },
            {
                id: 9,
                label: "Agent Score",
                url: "#",
                Icon: award
            },
            {
                id: 10,
                label: "Agent Monitor",
                url: "#",
                Icon: monitor
            },
            {
                id: 11,
                label: "Schedule",
                url: "#",
                Icon: calendar
            }]
        })
    }
    return menus;
}

export default getMenu;
